export default {
    addGroupHoliday: 'เพิ่มวันหยุดเฉพาะกลุ่ม',
    editGroupHoliday: 'แก้ไขวันหยุดเฉพาะกลุ่ม',
    groupHolidayName: 'ชื่อวันหยุดเฉพาะกลุ่ม',
    forGroup: 'สำหรับกลุ่ม',
    holidayDate: 'วันที่หยุด',
    description: 'คำอธิบาย',
    save: 'บันทึก',
    msgError: 'เกิดข้อผิดพลาด',
    congratulation: 'ยินดีด้วย',
    msgErrorStartTimeAndEndTime: 'วันที่ถูกสร้างควรจะน้อยกว่าวันที่สิ้นสุด',
    msgCreateSuccess: 'วันหยุดเฉพาะกลุ่มถูกสร้างแล้ว',
    msgUpdateSuccess: 'วันหยุดเฉพาะกลุ่มถูกอัปเดตแล้ว',
    msgRequiredField: 'กรุณากรอกข้อมูล',
    msgLimitCharacters: 'ช่องนี้รองรับตัวอักษรไม่เกิน 255 ตัวอักษร'
}
